import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { WelfareBenefitsListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { WELFARE_BENEFITS_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 待遇・福利厚生の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 待遇・福利厚生の初期配列
 */
export const createInitialWelfareBenefitsList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: WelfareBenefitsListType[] = [
    {
      id: OP_SEARCH_ITEMS.retirementBenefitPlan.id,
      name: OP_SEARCH_ITEMS.retirementBenefitPlan.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.retirementBenefitPlan.id
      ),
      value: WELFARE_BENEFITS_CODE_AND_QUERY.RETIREMENT_BENEFIT_PLAN.code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.RETIREMENT_BENEFIT_PLAN.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.companyHousingAndEentSubsidySystem.id,
      name: OP_SEARCH_ITEMS.companyHousingAndEentSubsidySystem.name,
      isChecked: paramList.some(
        (query) =>
          query === OP_SEARCH_ITEMS.companyHousingAndEentSubsidySystem.id
      ),
      value:
        WELFARE_BENEFITS_CODE_AND_QUERY.COMPANY_HOUSING_AND_ENT_SUBSIDY_SYSTEM
          .code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.COMPANY_HOUSING_AND_ENT_SUBSIDY_SYSTEM
          .code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.childcareAndChildcareSupportSystem.id,
      name: OP_SEARCH_ITEMS.childcareAndChildcareSupportSystem.name,
      isChecked: paramList.some(
        (query) =>
          query === OP_SEARCH_ITEMS.childcareAndChildcareSupportSystem.id
      ),
      value:
        WELFARE_BENEFITS_CODE_AND_QUERY.CHILDCARE_AND_CHILDCARE_SUPPORT_SYSTEM
          .code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.CHILDCARE_AND_CHILDCARE_SUPPORT_SYSTEM
          .code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.qualificationAcquisitionSupportSystem.id,
      name: OP_SEARCH_ITEMS.qualificationAcquisitionSupportSystem.name,
      isChecked: paramList.some(
        (query) =>
          query === OP_SEARCH_ITEMS.qualificationAcquisitionSupportSystem.id
      ),
      value:
        WELFARE_BENEFITS_CODE_AND_QUERY.QUALIFICATION_ACQUISITION_SUPPORT_SYSTEM
          .code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.QUALIFICATION_ACQUISITION_SUPPORT_SYSTEM
          .code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.fullTrainingSystem.id,
      name: OP_SEARCH_ITEMS.fullTrainingSystem.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.fullTrainingSystem.id
      ),
      value: WELFARE_BENEFITS_CODE_AND_QUERY.FULL_TRAINING_SYSTEM.code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.FULL_TRAINING_SYSTEM.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.salaryOf250kYenMore.id,
      name: OP_SEARCH_ITEMS.salaryOf250kYenMore.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.salaryOf250kYenMore.id
      ),
      value: WELFARE_BENEFITS_CODE_AND_QUERY.SALARY_OF_250K_YEN_MORE.code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.SALARY_OF_250K_YEN_MORE.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.salaryOf350kYenMore.id,
      name: OP_SEARCH_ITEMS.salaryOf350kYenMore.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.salaryOf350kYenMore.id
      ),
      value: WELFARE_BENEFITS_CODE_AND_QUERY.SALARY_OF_350K_YEN_MORE.code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.SALARY_OF_350K_YEN_MORE.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.UIturnSupport.id,
      name: OP_SEARCH_ITEMS.UIturnSupport.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.UIturnSupport.id
      ),
      value: WELFARE_BENEFITS_CODE_AND_QUERY.U_ITURN_SUPPORT.code,
      jobCount: findJobCount(
        jobCountData.welfareBenefitsList,
        WELFARE_BENEFITS_CODE_AND_QUERY.U_ITURN_SUPPORT.code
      ),
    },
  ];

  return initialData;
};
